import { BaseNumber, CheckedAddress, NormalizedNumber } from '@sparkdotfi/common-universal'

import { TokenSymbol } from './TokenSymbol'

export interface TokenDefinitionConstructorParams {
  symbol: TokenSymbol
  name: string
  decimals: number
  address: CheckedAddress
  logo: string
}

export class TokenDefinition {
  readonly symbol: TokenSymbol
  readonly name: string
  readonly decimals: number
  readonly address: CheckedAddress
  readonly logo: string

  constructor({
    symbol,
    name,
    decimals,
    address,
    logo,
  }: {
    symbol: TokenSymbol
    name: string
    decimals: number
    address: CheckedAddress
    logo: string
  }) {
    this.decimals = decimals
    this.symbol = symbol
    this.name = name
    this.address = address
    this.logo = logo
  }

  public toBaseNumber(value: NormalizedNumber): BaseNumber {
    return value.toBaseNumber(this.decimals)
  }

  toBigInt(value: NormalizedNumber): bigint {
    return value.toBaseNumber(this.decimals).toBigInt()
  }

  public fromBaseUnit(value: BaseNumber): NormalizedNumber {
    return value.toNormalizedUnit(this.decimals)
  }

  public clone({
    address,
    symbol,
    name,
    decimals,
    logo,
  }: {
    address?: CheckedAddress
    symbol?: TokenSymbol
    name?: string
    decimals?: number
    logo?: string
  }): TokenDefinition {
    return new TokenDefinition({
      address: address ?? this.address,
      symbol: symbol ?? this.symbol,
      name: name ?? this.name,
      decimals: decimals ?? this.decimals,
      logo: logo ?? this.logo,
    })
  }
}
